import { getFetch } from '@sift/resift/redux/FetchUtils';
import { THEMES_GET_ALL_FETCH } from 'store/themes';

const identifier = 'THEMES_GET_THEMES_IDENTIFIER';

export function fetchThemes() {
  return {
    type: THEMES_GET_ALL_FETCH,
    identifier,
    payload: {},
  };
}

export function getThemesFetch(state) {
  return getFetch(identifier, state);
}
